__webpack_require__.p = "/reports-number-formatting/referrals-hub/";